import { StudentLaptopsPage } from "@/pages/cursisten/$studentId/laptops"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/cursisten/$studentId/laptops/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { studentId } = useParams({ from: Route.id })

  return <StudentLaptopsPage studentId={Number(studentId)} />
}
